import { useQuery } from '@/lib/useWrappingQuery';
import { sellerInfoQueryOptions } from './options';

export const useSellerInfoQuery = (salePageId: number) => {
  return useQuery({
    ...sellerInfoQueryOptions.getSellerInfo({ pathVariables: salePageId }),
    enabled: salePageId > 0,
  });
};
